export const environment = {
    production: false,
    accounts_api: 'https://api.billing.hearx.staging.hearxgroup.com',
    accounts_token: '40zGVsU1i6eHIQUxNTw4WABRbdS1jtTn',
    heardata_api: 'https://api.mhealth.staging.hearxgroup.com',
    license_api: 'https://api.licenses.staging.hearxgroup.com',
    hardware_api: 'https://api.calibrations.staging.hearxgroup.com',
    hardware_token: 'abcdefg',
    leads_api: '',
    leads_token: '',
};




// WEBPACK FOOTER //
// ./src/environments/environment.ts